import { createFileRoute } from '@tanstack/react-router';

import { OrderPointsPage } from '@sampling';

export const Route = createFileRoute('/_app/_admin/orders_/$id/points')({
  component: OrderPointsPage,
});
